import { new__cn } from '../util';

const style = {
  vPopover: new__cn(
    'fixed',
    'top-(--popover-top)',
    'left-(--popover-left)',
    'bg-white',
    'rounded-sm border border-gray-200',
    'shadow-sm',
    'z-4000',
  ),
} as const;

export default style;
